/**
 * PreMize facts. These are the ONLY place on the page the performance numbers
 * appear — the old site repeated them in three sections.
 */

export interface Stat {
  value: string;
  unit?: string;
  label: string;
}

export const STATS: readonly Stat[] = [
  { value: '0.66', unit: 's', label: 'to the first word, with 16 people chatting at once' },
  { value: '125', unit: 'tokens/s', label: 'total writing speed under load' },
  { value: '128', unit: 'GB', label: 'unified memory on one NVIDIA DGX Spark' },
];

/** What the numbers were measured on. Both `null` until the owner confirms;
 *  the caption then names the model and month. */
export const MEASURED: { model: string | null; month: string | null } = {
  model: null,
  month: null,
};

export function measuredCaption(): string {
  const on = MEASURED.model ? ` running ${MEASURED.model}` : '';
  const when = MEASURED.month ? `, ${MEASURED.month}` : '';
  return `Measured by AGICAFET on our production DGX Spark${on}${when}.`;
}

export interface Term {
  title: string;
  line: string;
}

export const TERMS: readonly Term[] = [
  { title: 'One-time cost', line: 'Buy the hardware once. No bill per question.' },
  { title: 'Works offline', line: 'Runs inside your network, even with the internet down.' },
  { title: 'Plugs in', line: 'An OpenAI-compatible API, so existing tools connect as they are.' },
  { title: 'We look after it', line: 'We install it, tune it, train your team and support it. You own it.' },
];
